import React from "react";

import { IDemoPersistedRoiRequest } from "../../roi-request-create/model/roi-request-create.storage";

export const useRoiRequestDuplicate = () => {
  const [duplicateRequest, setDuplicateRequest] =
    React.useState<IDemoPersistedRoiRequest | null>(null);
  const [duplicateSuccessRequestId, setDuplicateSuccessRequestId] =
    React.useState<number | null>(null);

  const openDuplicateDialog = React.useCallback(
    (request: IDemoPersistedRoiRequest) => {
      setDuplicateRequest(request);
    },
    [],
  );

  const closeDuplicateDialog = React.useCallback(() => {
    setDuplicateRequest(null);
  }, []);

  const handleDuplicateSuccess = React.useCallback(
    (request: IDemoPersistedRoiRequest) => {
      setDuplicateRequest(null);
      setDuplicateSuccessRequestId(request.request_id);
    },
    [],
  );

  const dismissDuplicateSuccess = React.useCallback(() => {
    setDuplicateSuccessRequestId(null);
  }, []);

  return {
    duplicateRequest,
    duplicateSuccessRequestId,
    openDuplicateDialog,
    closeDuplicateDialog,
    handleDuplicateSuccess,
    dismissDuplicateSuccess,
  };
};
